import {DetailsControlType} from 'shared/details-page/details-control/details-control-type';

export const collapseWidth = 83;
export const collapseWidthPx = `${collapseWidth}px`;
export const collapseWidthPercents = '5%';
export const defaultPriceSheetWidth = '15%';

export const rowData: Array<any> = [
  {
    fieldName: 'priceSheetName',
    width: '20%',
  }, {
    fieldName: 'priceSheetNumber',
    width: '20%',
  }, {
    fieldName: 'currencyCode',
    width: '20%',
    type: DetailsControlType.MultiSelect,
  }, {
    fieldName: 'effectiveDate',
    width: '20%',
    type: DetailsControlType.Date,
  },
];

export const contentData: Array<any> = [
  [{
    fieldName: 'priceZone',
    width: '50%',
  }, {
    fieldName: 'expirationDate',
    width: '50%',
    type: DetailsControlType.Date,
  }]
];
